define(
  'app/views/offline_hotel_request_form_view',[
    'app/setup',
    'app/lib/pwt/persian-date',
    'app/lib/pwt/persian-datepicker',
    'jquery.selectric'
  ],
  function (takhfifan, persianDate) {
    takhfifan.OfflineHotelRequestForm = Backbone.View.extend({
      events: {
        'click .tkh-offline-hotel-request-form__button': 'submit'
      },

      initialize: function () {
        window.persianDate = persianDate;
        this.$el.removeClass('loading-view');
        this.initializeCalendar();

        takhfifan.eventHub.on('hotelOffline:requestFormReset', function () {
          this.resetForm();
        }, this);
        this.$el.find('#room').selectric();
        takhfifan.eventHub.on('hotelOffline:showRequestForm', function () {
          takhfifan.eventHub.trigger('hotelOffline:requestFormReset');
          takhfifan.eventHub.trigger(
            'modal:showModalWithContent', {
              elementToOperate: this.$el,
              fadeTimeIn: 400
            });
        }, this);
      },

      initializeCalendar: function () {
        var _this = this,
            couponEndDate = _this.$el.find('input[name="coupon-end-date"]').val(),
            expireDate = new Date(couponEndDate);

        $('.tkh-offline_hotel_request__calendar').persianDatepicker({
          inline: true,
          minDate: new Date(),
          maxDate: expireDate,
          toolbox: {
            calendarSwitch: {
              enabled: false
            }
          },
          onSelect: function (unix) {
            _this.$el.find('input[name="checkin"]').val(_this.formatDate(unix));
            var isMobile = {
              Android: function() {
                return navigator.userAgent.match(/Android/i);
              },
              BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
              },
              iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
              },
              Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
              },
              Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
              },
              any: function() {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
              }
            };
            if (isMobile.any()){
              var modal = $('#offline_hotel_request__wrapper'),
                  scrollTo = $('#offline_hotel_request__form_field'),
                  distance = scrollTo.offset().top - modal.offset().top + modal.scrollTop();
              modal.animate({scrollTop: distance }, "slow");
            }
          }
        });
         // var unix= _this.$el.find('.today').data('unix');
        // _this.$el.find('input[name="checkin"]').val(unix);
      },

      formatDate: function (unix) {
        var currentDate = new Date(unix);
        return (currentDate.getFullYear() + "-"
          + this.addLeadingZero(currentDate.getMonth() + 1) + "-"
          + this.addLeadingZero(currentDate.getDate()));
      },

      addLeadingZero: function (n) {
        var s = "0" + n;
        return s.substr(s.length - 2);
      },

      resetForm: function () {
        this.$el.find('form').find('input[type=text]').val("");
        this.$el.find('form').find('select').prop('selectedIndex', 0);

        var $nightSelectBox = this.$el.find('select[name="night"]');
        $nightSelectBox.children().remove();
        $nightSelectBox.append($('<option value="" disabled selected>تعداد شب</option>'));
        for (var i = 1; i < 11; ++i) {

          $nightSelectBox.append($('<option value="' + i + '">' + i + '</option>'));
        }
      },

      submit: function (e) {
        var _submitButton = document.getElementById("offline_hotel_request_form__button");

        _submitButton.disabled =true;
        var _this = this;
        e.preventDefault();
        var formData = this.gatherCustomerData();
        if (formData != null) {
          this.$el.find('form').addClass('loading-view');
          $.ajax({
            type: 'POST',
            url: '/ajax/forms/saveOfflineHotel',
            data: formData
          }).done(function (data) {
            if (data && !data.success) {
              var message = "خطایی در ثبت اطلاعات پیش آمد. لطفا دوباره تلاش نمایید.";
              if (data.code === 429) {
                message = 'درخواست شما ثبت نشد. شما میبایست تا تعیین وضعیت درخواست های قبلی منتظر بمانید';
              }
              takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: message
              });
              takhfifan.eventHub.trigger('offline_form:error', 'Register Error:' + (data.message || 'unknown error'));
            } else {
              takhfifan.eventHub.trigger('message:show', {
                type: 'success',
                msg: data.message
              });
            }
          }).fail(function () {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'خطایی در ارتباط با سرور پیش آمد. لطفا دوباره تلاش نمایید.'
            });
            takhfifan.eventHub.trigger('offline_form:error', 'Register Error:RequestFailed');
          }).always(function () {
            _submitButton.disabled =false;
            _this.$el.find('form').removeClass('loading-view');
            takhfifan.eventHub.trigger('modal:closeModalWithContent');
          });
        } else {
          _submitButton.disabled =false;
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "اطلاعات فرم به درستی وارد نشده است. لطفا دوباره تلاش نمایید"
          });
          takhfifan.eventHub.trigger('modal:closeModalWithContent');
        }
      },

      gatherCustomerData: function () {
        try {
          var formData = {
            formKey: takhfifan.formKey,
            firstname: this.$el.find('input[name="first-name"]').val(),
            lastname: this.$el.find('input[name="last-name"]').val(),
            email: this.$el.find('input[name="email"]').val(),
            mobile: this.$el.find('input[name="mobile"]').val(),
            telephone: this.$el.find('input[name="tel"]').val(),
            checkin_date: this.$el.find('input[name="checkin"]').val(),
            number_of_nights: this.$el.find('#numberOfNight').val(),
            passenger_count: this.$el.find('input[name="passenger-count"]').val(),
            hotel_id: this.$el.find('input[name="parent-id"]').val(),
            product_id: this.$el.find('#room').val(),
            user_note: this.$el.find('textarea[name="user-note"]').val()
          };
          for (var key in formData) {
            if (!formData[key] && key !== 'user_note' && key !== 'telephone') {
              throw key + 'is not set';
            }
          }
          return formData;
        } catch (e) {
          takhfifan.eventHub.trigger('offline_form:error', 'Fill Error:' + e);
          console.log(e);
          return null;
        }
      },
    })
  });

